import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import AppRoutesContent from './AppRoutesContent'
import { AuthProvider } from '../context/AuthContext'
import { ApplicationProvider } from '../context/ApplicationContext'
import { OrganProvider } from '../context/OrganContext'
import { PermissionsProvider } from '../context/PermissionsContext'
import { LoaderProvider } from '../context/LoaderContext'
import GlobalLoader from '../components/GlobalLoader'
import { ReportProvider } from '../context/ReportContext'

const AppRoutes = () => {
  return (
    <Router>
      <LoaderProvider>
        <AuthProvider>
          <PermissionsProvider>
            <ReportProvider>
              <ApplicationProvider>
                <OrganProvider>
                  <AppRoutesContent />
                  <GlobalLoader />
                </OrganProvider>
              </ApplicationProvider>
            </ReportProvider>
          </PermissionsProvider>
        </AuthProvider>
      </LoaderProvider>
    </Router>
  )
}

export default AppRoutes
